<kendo-buttongroup class="ti-button-group" selection="single">
  <button
    *ngFor="let button of options"
    [disabled]="button?.disabled || form.disabled"
    kendoButton
    kendoTooltip
    [themeColor]="'tertiary'"
    [toggleable]="true"
    [selected]="form.value === button.value"
    (selectedChange)="selectedChange(button)"
    filter=".with-tooltip"
    [ngClass]="{ 'with-tooltip': button?.tooltipWithoutIcon }"
    [tooltipTemplate]="tooltip"
    [iconClass]="button?.iconClass">
    {{ button.label }}
    @if (button.count !== null && button.count !== undefined) {
      <span class="count">{{ button.count }}</span>
    }
    @if (button?.tooltip) {
      <span kendoTooltip class="help-info fa fa-question-circle" [title]="button?.tooltip"></span>
    }
    <ng-template #tooltip>
      <span>{{ button?.tooltipWithoutIcon }}</span>
    </ng-template>
  </button>
</kendo-buttongroup>
